import { Button, Col, Row, Segmented } from "antd";
import React, { useEffect, useState } from "react";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import { PlusOutlined } from "@ant-design/icons";
import EditIcon from "../../../ui/EditIcon";
import SpeechSwallowReviewSummary from "./SpeechSwallowReviewSummary";
import SpeechSwallowReviewForm from "./SpeechSwallowReviewForm";
import dayjs from "dayjs";
import NoDataPage from "../../../NoDataPages/NoDataPage";
import noReview from "../../../../assets/doctorIcons/noReview.svg";
import LoadingIndicator from "../../../Loaders/LoadingIndicator";
import useQuery from "../../../../hooks/useQuery";
import useIsMobile from "../../../../hooks/useIsMobile";
import "../../Doctor/DailyReview/DailyReview.css";

const SpeechSwallowReview = ({
  refreshPage,
  reviewData,
  iAssessment,
  patientData,
}) => {
  const [visible, setVisible] = useState(false);
  const [activeSegment, setActiveSegment] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [addMode, setAddMode] = useState(false);
  const [dailyRefresh, setDailyRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const isMobile = useIsMobile();
  const setDailyReviewRefresh = () => {
    setDailyRefresh((prev) => !prev);
  };
  const isActive = useQuery()?.status === "current";

  useEffect(() => {
    if (reviewData) setLoading(false);
    if (reviewData?.length > 0) {
      setActiveSegment(reviewData[0]?.id);
    }
  }, [reviewData]);

  const segmentData = reviewData?.map((item) => ({
    label: `${dayjs(item?.created_at).format("MMM DD")}, ${dayjs(
      item?.created_at
    ).format("h:mm A")}`,
    value: item?.id,
  }));

  const handleAddReview = () => {
    setEditMode(false);
    setActiveSegment(null);
    setVisible(true);
    setAddMode(true);
  };

  const handleEditReview = () => {
    setEditMode(true);
    setVisible(true);
  };

  return (
    <div className="daily-review-page">
      {loading ? (
        <LoadingIndicator message={"Loading..."} />
      ) : (
        <>
          {reviewData?.length > 0 ? (
            <Row gutter={[12, 12]} style={{ marginTop: "0px" }}>
              <Col span={24}>
                <div className="daily-review-toolbar">
                  <div className="daily-review-toolbar__left">
                    {isActive && (
                      <Button
                        type="primary"
                        onClick={handleAddReview}
                        className={`${btnStyles.lgBtn} inv-btn daily-review-toolbar__add`}
                        style={{ marginRight: "15px", fontWeight: 500 }}
                      >
                        <PlusOutlined /> Review
                      </Button>
                    )}
                    <div className="daily-review-toolbar__dates">
                      <Segmented
                        className="daily-review-date-segment"
                        value={activeSegment}
                        options={segmentData}
                        onChange={setActiveSegment}
                        size="middle"
                        style={{
                          boxShadow: "2px 2px 3px #e3e4e6",
                        }}
                      />
                    </div>
                  </div>

                  {isActive && (
                    <Button
                      type="primary"
                      onClick={handleEditReview}
                      className={`${btnStyles.lgBtn} inv-btn daily-review-toolbar__edit`}
                      disabled={!activeSegment}
                      style={{ fontWeight: 500 }}
                    >
                      <EditIcon />
                      Edit
                    </Button>
                  )}
                </div>
              </Col>
              <Col span={24}>
                <SpeechSwallowReviewSummary
                  editId={activeSegment}
                  dailyRefresh={setDailyReviewRefresh}
                  isActive={isActive}
                  onEdit={handleEditReview}
                  canEdit={!!activeSegment}
                />
              </Col>
            </Row>
          ) : (
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: isMobile ? "auto" : "80vh",
                padding: isMobile ? "24px 0 32px" : undefined,
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>
                <NoDataPage
                  title={
                    isActive
                      ? "Review Not Yet Submitted"
                      : "Review Form Not Available"
                  }
                  subtitle={
                    isActive ? "Kindly, upload review here" : undefined
                  }
                  image={noReview}
                />
                {isActive && (
                  <Button
                    type="primary"
                    onClick={handleAddReview}
                    className={`${btnStyles.lgBtn} inv-btn `}
                  >
                    Review Form
                  </Button>
                )}
              </Col>
            </Row>
          )}
        </>
      )}
      {visible && (
        <SpeechSwallowReviewForm
          visible={visible}
          setVisible={setVisible}
          refreshPage={refreshPage}
          editId={editMode ? activeSegment : null}
          iAssessment={iAssessment}
          addMode={addMode}
          setAddMode={setAddMode}
          setActiveSegment={setActiveSegment}
          reviewData={reviewData}
          setDailyReviewRefresh={setDailyReviewRefresh}
          dailyRefresh={dailyRefresh}
          segmentData={segmentData}
          patientData={patientData}
        />
      )}
    </div>
  );
};

export default SpeechSwallowReview;
